import { Integration_Handler_Names_Enum } from '@main/graphql/types.admin.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { MdmService } from '../../service';

export type ScreenLockTimerConfig = typeof ScreenLockTimerConfig._.Config;

export const ScreenLockTimerConfig = IntegrationConfig.make({
  service: MdmService,
  name: Integration_Handler_Names_Enum.ScreenLockTimer,
  configSchema: z.object({
    maximumLockTimerSeconds: z.number().optional(),
    systemPatternFilter: patternFilterSchema.optional(),
  }),
});
